import './close-report-screen.scss'

import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { ConditionReport, ConditionReportDataStore } from '@skinsoft/entity';
import { id, referenceNumber } from '@skinsoft/entity/src/condition-report/selectors';
import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchFeatured } from '@skinsoft/ui';

import { CLOSE_CLOSE_REPORT_SCREEN_TOPIC, DISPLAY_ALERT_TOPIC } from '../../../busTopics';
import { router, Routes } from '../../../router';
import { PDFGenerator } from '../../pdf-overview-screen/pdf-generator/pdf-generator';

@Component({
    props: ['conditionReport', 'searchFeatured', 'fieldName', "form"],
    template: require('./close-report-screen.html')
})
export class CloseReportScreen extends ReactiveVue {

    public conditionReport: ConditionReport;
    public searchFeatured: SearchFeatured;
    public fieldName: string;
    public form: FormApi;

    // Icons
    private backIcon = faArrowLeft;
    private checkIcon = faCheck;

    private $conditionReportDataStore: ConditionReportDataStore;
    private $mediaTransferHelper: MediaTransferHelper

    private closingStatus: string = "";
    private closingInProgress: boolean = false;

    private closeCloseReportScreen() {
        this.emitOnBus(CLOSE_CLOSE_REPORT_SCREEN_TOPIC)
    }

    private async handleCloseReport() {
        this.closingInProgress = true;
        this.closingStatus = this.$t('closeReportScreen.fileGeneration') as string;
        PDFGenerator.generatePDF(this.conditionReport, this.searchFeatured, async (blob) => {
            this.closingStatus = this.$t('closeReportScreen.transferingFile') as string;

            const pdfFileUrl = window.URL.createObjectURL(blob)
            const fileName = `${referenceNumber(this.conditionReport)}.pdf`
            const withName = new File([blob], fileName)

            // PDF upload
            const docNotice = await this.$mediaTransferHelper.uploadPDFDocument(withName, pdfFileUrl)
            this.closingStatus = this.$t('closeReportScreen.reportClosing') as string;
            // Attaching the new document to condition report entity
            let medias: any[] = get(this.form.getState().values, `${this.fieldName}.medias`)
            if (!medias) {
                medias = []
            }
            medias.push(docNotice)
            // Setting generated pdf as main media of the report entity
            set(this.form.getState().values, `${this.fieldName}.first`, docNotice.mediaId)
            // Saving report
            await this.form.submit()
            await this.$conditionReportDataStore.closeConditionReport(id(this.conditionReport))

            // Going back to closed report screen
            router.push({ name: Routes.CLOSE_REPORTS });
            this.emitOnBus(DISPLAY_ALERT_TOPIC, {
                message: this.$t('closeReportScreen.notificationContent', { referenceNumber: referenceNumber(this.conditionReport) }),
                variant: "success"
            })
        })
    }
}